
import React from 'react';
import Layout from '@/components/layout/Layout';
import ChippieChatInterface from '@/components/chippie/ChippieChatInterface';

const ChippieAI: React.FC = () => {
  return (
    <Layout fullWidth hideHeader>
      <div className="h-screen">
        <ChippieChatInterface />
      </div>
    </Layout>
  );
};

export default ChippieAI;
